import * as ko from "knockout";
import * as _ from "underscore";

// Helpers
import "knockoutCustomBindings";

// Models
import AlertBase, { IAlert } from 'Content/ts/Shared/BootstrapAlerts/AlertBase';

export interface IAlertInfoIcon extends IAlert {
    Icon: string | KnockoutObservable<string>;       // Required
}

export default class AlertInfoIcon extends AlertBase {
    icon: string | KnockoutObservable<string>;

    constructor(params: IAlertInfoIcon) {
        super(params);

        // Component Validation
        if (params.Icon == null || params.Icon == undefined) {
            params.Icon = 'fa-exclamation-circle'
        }

        // Provided Component Properties
        this.icon = params.Icon;
    }
}

const componentName = "alert-info-icon";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: AlertInfoIcon,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertInfo/${componentName}.html` }
});